type AttemptState = { attempts: number[] };
type AuthAction = 'login' | 'register' | 'password-reset';

const keyFor = (action: AuthAction) => `pl_auth_attempts_${action}`;

export const getAuthRetryAfter = (action: AuthAction, maxAttempts: number, windowMs: number) => {
  const now = Date.now();
  let state: AttemptState = { attempts: [] };
  try { state = JSON.parse(localStorage.getItem(keyFor(action)) || '{"attempts":[]}'); } catch { /* ignore invalid local state */ }
  const attempts = (state.attempts || []).filter(value => now - value < windowMs);
  localStorage.setItem(keyFor(action), JSON.stringify({ attempts }));
  if (attempts.length < maxAttempts) return 0;
  return Math.max(1, Math.ceil((windowMs - (now - attempts[0])) / 1000));
};

export const recordAuthAttempt = (action: AuthAction, windowMs: number) => {
  const now = Date.now();
  let state: AttemptState = { attempts: [] };
  try { state = JSON.parse(localStorage.getItem(keyFor(action)) || '{"attempts":[]}'); } catch { /* ignore invalid local state */ }
  const attempts = (state.attempts || []).filter(value => now - value < windowMs);
  localStorage.setItem(keyFor(action), JSON.stringify({ attempts: [...attempts, now] }));
};

export const clearAuthAttempts = (action: AuthAction) => localStorage.removeItem(keyFor(action));
